import { PermissionsList } from '@/helpers/permissions.js';

const mutations = {
  setAccessToken(state, payload) {
    state.accessToken = payload;
  },
  setExpiryTokenDate(state, payload) {
    state.expiryTokenDate = payload;
  },
  logout(state) {
    state.accessToken = null;
    state.expiryTokenDate = null;
  },
  setProfile(state, payload) {
    state.user.id = payload.id;
    state.user.email = payload.email;
    state.user.full_name = payload.full_name;
  },
  setRoles(state, payload) {
    state.roles = {};
    if (payload.roles.data) {
      payload.roles.data.forEach(item => {
        state.roles[item.slug] = true;
      });
    }
  },
  resetPermissions(state) {
    state.permissions = Object.keys(PermissionsList).reduce((result, key) => {
      result[PermissionsList[key]] = false;
      return result;
    }, {});
  },
  setPermissions(state, payload) {
    if (state.roles.admin) {
      Object.keys(state.permissions).map(key => {
        state.permissions[key] = true;
      });
      return
    }
    if (payload.permissions.data) {
      payload.permissions.data.forEach(item => {
        state.permissions[item.slug] = true;
      });
    }
  },
};

export default mutations;
